export default {
  data() {
    return {
      props: {
        'tag': '',
        'width': '300px',
        'height': '300px',
        'zIndex': 'auto','maxWidth': '500px',
        'rotation': '0deg',
        'border': '0 none #000000',
        'boxShadow': '0 0 0 0 black initial',
        'borderRadius': '0 0 0 0',
        'paddingTop': '15px',
        'paddingLeft': '15px',
        'paddingRight': '15px',
        'paddingBottom': '15px',
        'src': 'https://player.vimeo.com/video/150929970',
        'checkBoxAutoPlay': 'false',
        'checkBoxLoop': 'false',
        
        //Elements for StickyVideo
        'StickyVideo' : false,
        'positionSticky' : '',
        'btnClick' : '',
        'sizeSticky' : '',
        'ative' : false,

          'animation': {
          'in': {
            'action': 'time',  //time/scroll/click/hover
            'time': 0,       // sec
            'scroll': 0,     // px
            'effect': 'none',
            'speed': 'slow',
            'infinite': false,
          },
          'out': {
            'action': 'time',   //time/scroll/click
            'time': 0,       // sec
            'scroll': 0,     // px
            'effect': 'none',
            'delay': '1',
            'speed': '1',
            'infinite': false,
          },
        },
        
      },
      elements: [],
      internal_config: {
        'width': '300px',
        'height': '300px',
        'zIndex': 'auto',
        'rotation': '0deg',
        'border': '0 none #000000',
        'boxShadow': '0 0 0 0 black initial',
        'borderRadius': '0 0 0 0',
        'paddingTop': '15px',
        'paddingLeft': '15px',
        'paddingRight': '15px',
        'paddingBottom': '15px',
        'src': 'https://player.vimeo.com/video/150929970',
        'checkBoxAutoPlay': 'false',
        'checkBoxLoop': 'false',
        
        'pinConfig' : {
          'pin' : false,
          'pTop' : '0',
          'pBottom' : '0',
          'pLeft' : '0',
          'pRight' : '0',
          'position': ''
      },

        'animation': {
          'in': {
            'action': 'time',   //time/scroll/click/hover
            'time': 0,       // sec
            'scroll': 0,     // px
            'effect': 'none',
            'speed': 'slow',
            'infinite': false,
          },
          'out': {
            'action': 'time',   //time/scroll/click
            'time': 0,       // sec
            'scroll': 0,     // px
            'effect': 'none',
            'delay': '1',
            'speed': '1',
            'infinite': false,
          },
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/apps/Vimeo/Model.js